module.exports = __webpack_public_path__ + "img/Ivenak.d053b723.jpg";